import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/i18n";
import SmoothScroll from "@/components/SmoothScroll";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import ITPage from "@/pages/ITPage";
import TransportPage from "@/pages/TransportPage";
import RentalPage from "@/pages/RentalPage";
import ContactPage from "@/pages/ContactPage";
import LegalPage from "@/pages/LegalPage";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <SmoothScroll>
            <Navbar />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/it" element={<ITPage />} />
              <Route path="/transport" element={<TransportPage />} />
              <Route path="/transport/location" element={<RentalPage />} />
              <Route path="/transport/location" element={<RentalPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/mentions-legales" element={<LegalPage kind="legal" />} />
              <Route path="/confidentialite" element={<LegalPage kind="privacy" />} />
            </Routes>
            <Footer />
            <Toaster position="top-center" richColors />
          </SmoothScroll>
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
